// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1FO2o","controls":"styles_controls__qOG5w","select":"styles_select__1PMFB","text":"styles_text__i8o6L"};